import { ICreateStudy, IUpdateStudy } from "../../Interfaces/Apis/Study.interface";
import { BaseAPI } from "../Common";

class Study extends BaseAPI {
  create(payload: ICreateStudy): Promise<any> {
    return this.makeRequest(`create`, "post", payload);
  }
  createStudy(payload: ICreateStudy): Promise<any> {
    return this.makeRequest(`create-study`, "post", payload);
  }

  update(studyId: string, payload: IUpdateStudy): Promise<any> {
    return this.makeRequest(`${studyId}`, "patch", payload);
  }
  updateStudy(studyId: string, payload: IUpdateStudy): Promise<any> {
    return this.makeRequest(`update-study/${studyId}`, "patch", payload);
  }

  getAllStudies(): Promise<any> {
    return this.makeRequest(`studies/by-tenant`, "get");
  }

  async import( file: File, attachmentData: any) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("attachmentData", JSON.stringify(attachmentData));

    return await this.makeRequest("create-study/import", "post", formData, true);
  }


  getAll(): Promise<any> {
    return this.makeRequest(`all`);
  }

  getStudy(studyId: string): Promise<any> {
    return this.makeRequest(`${studyId}`);
  }
}

export const study = new Study("study");
